/**
 * The path component of the Moyasar redirect target. The path the
 * dashboard renders the post-payment confirmation screen at —
 * Moyasar appends `?id=<paymentId>&status=…` to it on redirect.
 *
 * Used in three places, all of which import this constant rather than
 * hardcoding the string:
 *
 * 1. Frontend route registry — `appRoutes.billing_checkout_return.path`
 *    in `libs/frontend/web/hooks/src/navigation/routes/billing.ts`.
 *    Drives React Router so the redirect actually mounts a page.
 * 2. Frontend checkout URL builder — `useBillingReturnUrl()` in
 *    `libs/frontend/web/hooks/src/billing/useBillingReturnUrl.ts`.
 *    Pairs it with `window.location.origin` so dashboard-initiated
 *    checkouts always redirect back to whatever host the user is on
 *    (localhost, tunnel, staging, production — automatically).
 * 3. Backend renewal-cron callback —
 *    `MOYASAR_CONFIG.renewalCallbackUrl` in
 *    `apps/backend/src/app/moyasar/moyasar.config.ts`. Pairs it with
 *    `MOYASAR_CONFIG.webAppOrigin` (the env-branched / env-overridable
 *    "what host is the dashboard at right now"), because the cron
 *    runs server-side with no browser context to read `origin` from.
 *
 * Renaming this path is therefore a one-line change here; every
 * consumer falls in line automatically.
 */
export const BILLING_CHECKOUT_RETURN_PATH = '/billing/checkout/return';
